import styles from "./Navbar.module.css"
import { useState } from 'react';
import { Link } from "react-scroll";
import AccountMenu from "./menu";

export const Navbar = () => {

    const [clicked, setClicked] = useState("Home")

    const navData = ["Home", "About me", "Projects", "Skills", "Contact"]

    const SectionClicked = (e) => {
        setClicked(e.target.innerHTML)
    }

    return <div className={styles.navbar_Container}>
        <div className={styles.navbar_inside_Container}>
            <div>
                <img src="./pratik_portfolio.gif" alt="mylogo" />
            </div>
            <div className={styles.navbar_Sections}>

                {navData.map((e) => {
                    return (
                        <Link to={e} smooth={true} spy={true} activeClass={styles.active} duration={1000}>
                            <p key={e} className={styles.Ptag} onClick={SectionClicked} style={{ color: clicked === e ? "#111827" : "#9CA3AF", fontWeight: clicked === e ? "700" : "200" }}>{e}</p>
                        </Link>)
                })}
                <button>
                    <a href="./Pratik.pdf" download="Pratik.pdf">
                        RESUME
                    </a>
                </button>
            </div>

            <div className={styles.Account}>
                <AccountMenu />
            </div>

        </div>

    </div>
}